<!--
//================================================================================
// ID:-
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:App
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/07/09 | 富士通株式会社         | 新規作成
// 01.04.00 | 2023/04/26 | 富士通Japan株式会社    | 令和5年度改修対応（1次リリース）
//================================================================================
-->
<template>
	<div id="app" class="main">
		<!-- 共通ヘッダ -->
		<global-header />
		<!-- メインコンテンツ -->
		<router-view/>
		<!-- ローディング -->
		<template v-if="isProgressFlg">
			<loading-view />
		</template>
		<!-- メッセージダイアログ -->
		<template v-if="isDialogFlg">
			<message-dialog
				v-bind:message="getMessage"
				v-bind:buttonList="getButtonList"
				v-bind:focusKey="getFocusKey"
			/>
		</template>
		<!-- 画面先頭へ戻る -->
		<return-top/>
	</div>
</template>

<script>
import GlobalHeader from '@/components/GlobalHeader.vue';
import MessageDialog from '@/components/MessageDialog.vue';
import Loading from '@/components/GlobalLoading.vue';
import ReturnTop from '@/components/ReturnTop.vue';

import { co_post } from '@/common/ajaxUtility.js';
import { co_pageBackCancel } from '@/common/keydownEventUtility.js';
//import { co_doLogout } from '@/common/logoutEventUtility.js';
import { co_isMobile } from '@/common/browserUtility.js'; 
import { co_kosuKaiho } from '@/common/zuijiUtility.js';

import {
		STORE_MSG_SET_MSG_INFO,STORE_ENV_SET_PARAMS,STORE_VIEW_IS_PROGRESS, STORE_VIEW_MOBILE,
		STORE_DIALOG_IS_DIALOG_FLG, STORE_DIALOG_GET_MESSAGE, STORE_DIALOG_GET_BUTTON_LIST, STORE_DIALOG_GET_FOCUS_KEY
		} from '@/const/store.js';
import { API_MESSAGE_INFO, API_ENV_PARAMS } from '@/const/route.js';

export default {

	components: {
		'global-header': GlobalHeader,
		'message-dialog': MessageDialog,
		'loading-view': Loading,
		'return-top': ReturnTop
	},
	computed: {
		isProgressFlg: function () {
			return this.$store.getters[STORE_VIEW_IS_PROGRESS];
		},
		isDialogFlg: function () {
			return this.$store.getters[STORE_DIALOG_IS_DIALOG_FLG];
		},
		getMessage: function () {
			return this.$store.getters[STORE_DIALOG_GET_MESSAGE];
		},
		getButtonList: function () {
			return this.$store.getters[STORE_DIALOG_GET_BUTTON_LIST];
		},
		getFocusKey: function () {
			return this.$store.getters[STORE_DIALOG_GET_FOCUS_KEY];
		}
	},
	created: async function () {

		// ショートカットキーによるページバックを禁止する
		window.addEventListener('keydown', co_pageBackCancel);

		// ブラウザの閉じるボタンで戸数解放（随時募集の場合のみ）
		window.addEventListener('beforeunload', co_kosuKaiho);

		// メッセージ情報取得
		let messageInfo = await co_post(API_MESSAGE_INFO);
		this.$store.commit(STORE_MSG_SET_MSG_INFO, messageInfo);

		// 環境変数取得
		let env = await co_post(API_ENV_PARAMS);
		this.$store.commit(STORE_ENV_SET_PARAMS, env);

		// モバイル表示有無
		let mobileFlg = await co_isMobile();
		this.$store.commit(STORE_VIEW_MOBILE, mobileFlg);

	},
	beforeDestroy: function () {
		// イベント削除
		window.removeEventListener('keydown', co_pageBackCancel);
		window.removeEventListener('beforeunload', co_kosuKaiho);
	}
}
</script>
<style>
@import "./css/reset.css";
@import "./css/modalDialog.css";
@import "./css/errorView.css";
@import "./css/header.css";
/* @import "./css/headerKensyo.css"; */
@import "./css/contentsButton.css";
@import "./css/contentsCommon.css";
@import "./css/eachInputItem.css";

body {
	background: #fdfdfd !important;
	-webkit-text-size-adjust: 100%;
}

#app {
	text-align: left;
	color: #262626;
	background-color: #fdfdfd;
}

/* 端末がPCの場合 */
@media screen and (min-width: 768px) {
	#app {
	min-width: 768px;
	max-width: 1080px;
	margin-left: auto;
	margin-right: auto;
	}
}

/* 端末がスマホの場合 */
@media screen and (max-width: 767px) {
	#app {
	min-width: 320px;
	max-width: 767px;
	}
}

.main {
	position: relative;
	background-color: #fdfdfd;
	font-family:	sans-serif;
	font-size: 16px;
	color: #262626;
}

/* 端末がPCの場合 */
@media screen and (min-width: 768px) {
	.main {
		min-width: 768px;
		max-width: 1080px;
		align-items: center;
		margin-left: auto;
		margin-right: auto;
		background-color: #fdfdfd;
		font-family: sans-serif;
		font-size: 18px;
		color: #262626;
	}
}

/* 端末がスマホの場合 */
@media screen and (max-width: 767px) {
	.main {
		align-items: center;
		background-color: #fdfdfd;
		font-family: sans-serif;
		font-size: 18px;
		color: #262626;
		width: 100%;
	}
}
</style>